// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { type AppValues } from '@tectonics/app-values';
import { fingerprint } from '@tectonics/prs/fingerprint';

export async function fingerprintOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
  appValues: AppValues,
  outgoingPayment: $Shape<OutgoingPayment>,
  tenantCode?: string,
): Promise<$Shape<OutgoingPayment>> {
  const deviceID = userInputValues['fingerprintUser'] || await fingerprint(incomingPayment);

  return {
    device_id: deviceID,
  };
}
